import React from "react";
import { Box, Paper, Stack, Typography, Chip } from "@mui/material";
import TableRestaurantIcon from "@mui/icons-material/TableRestaurant";
import PeopleIcon from "@mui/icons-material/People";
import { blue } from "@mui/material/colors";

/**
 * TableInfoBanner - Displays table information for INDOOR orders
 *
 * Props:
 * - tableInfo: { index, seats }
 *
 * Design: Blue background card with table icon, number, and seats
 */
const TableInfoBanner = ({ tableInfo }) => {
  if (!tableInfo) return null;

  return (
    <Paper
      elevation={0}
      sx={{
        p: 2,
        mb: 2,
        borderRadius: 3, // 12px
        bgcolor: blue[50],
        border: `1px solid ${blue[100]}`,
        boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
      }}
    >
      <Stack spacing={1}>
        <Stack direction="row" spacing={1} alignItems="center">
          <TableRestaurantIcon color="primary" />
          <Typography variant="h6" fontWeight="bold" color="primary.main">
            Mesa {tableInfo.index + 1}
          </Typography>
        </Stack>

        <Stack direction="row" spacing={1} alignItems="center">
          <PeopleIcon fontSize="small" color="action" />
          <Typography variant="body2" color="text.secondary">
            {tableInfo.seats || 4} lugares
          </Typography>
        </Stack>

        <Chip
          label="Pedido Mesa"
          size="small"
          color="primary"
          variant="outlined"
          sx={{ alignSelf: "flex-start" }}
        />
      </Stack>
    </Paper>
  );
};

export default TableInfoBanner;
